import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { getMsalInstance, loginRequest } from '../config/msalConfig';

const Login = () => {
  const [form, setForm]           = useState({ email: '', password: '' });
  const [loading, setLoading]     = useState(false);
  const [ssoLoading, setSsoLoading] = useState(false);
  const { login, loginWithSSO, isAuthenticated } = useAuth();

  if (isAuthenticated) return <Navigate to="/" replace />;

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Login successful!');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed. Check credentials.');
      setLoading(false);
    }
  };

  const handleMsLogin = async () => {
    setSsoLoading(true);
    try {
      const msal = await getMsalInstance();
      await msal.loginRedirect(loginRequest);
    } catch (err) {
      toast.error(err.message || 'Microsoft sign-in failed. Please try again.');
      setSsoLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex" style={{ background: '#f4f6fb' }}>

      {/* LEFT PANEL */}
      <div
        className="d-none d-lg-flex flex-column align-items-center justify-content-center col-lg-6"
        style={{ backgroundColor: '#F2652C', padding: '3rem', position: 'relative', overflow: 'hidden' }}
      >
        <div style={{ position: 'absolute', top: -80, right: -80, width: 320, height: 320, borderRadius: '50%', background: 'rgba(255,255,255,0.06)' }} />
        <div style={{ position: 'absolute', bottom: -60, left: -60, width: 240, height: 240, borderRadius: '50%', background: 'rgba(255,255,255,0.06)' }} />

        <div className="text-center text-white" style={{ position: 'relative', zIndex: 1 }}>
          <div className="mb-4">
            <div style={{ background: '#fff', borderRadius: 16, padding: '12px 20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
              <img src="/think-gas-logo.png" alt="Think Gas Logo" style={{ width: 110, height: 110, objectFit: 'contain' }} />
            </div>
          </div>
          <h1 className="fw-black mb-1" style={{ fontSize: '2.4rem', letterSpacing: '0.06em' }}>THINK GAS</h1>
          <p style={{ fontSize: '0.8rem', letterSpacing: '0.18em', opacity: 0.85, marginBottom: '2.5rem' }}>VISITOR ENTRY PORTAL</p>
        </div>

        <p className="text-white-50 small" style={{ position: 'absolute', bottom: 20 }}>
          &copy; {new Date().getFullYear()} Think Gas. All rights reserved.
        </p>
      </div>

      {/* RIGHT PANEL */}
      <div className="d-flex flex-column align-items-center justify-content-center col-12 col-lg-6 p-4">

        <div className="d-lg-none text-center mb-4">
          <div style={{ background: '#fff', borderRadius: 12, padding: '8px 14px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src="/think-gas-logo.png" alt="Think Gas" style={{ height: 60, objectFit: 'contain' }} />
          </div>
          <h4 className="fw-bold mt-2 mb-0" style={{ color: '#F2652C' }}>THINK GAS</h4>
          <p className="text-muted small" style={{ letterSpacing: '0.1em' }}>VISITOR ENTRY PORTAL</p>
        </div>

        <div className="w-100" style={{ maxWidth: 420 }}>
          <div className="mb-4">
            <h3 className="fw-bold mb-1" style={{ color: '#231F20' }}>Welcome back !</h3>
            <p className="text-muted mb-0">Sign in to access the visitor management portal</p>
          </div>

          <div className="card border-0 shadow rounded-4 p-4">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label fw-semibold small">Email Address</label>
                <div className="input-group">
                  <span className="input-group-text bg-light border-end-0">
                    <i className="bi bi-envelope text-muted"></i>
                  </span>
                  <input
                    type="email" name="email" className="form-control border-start-0 ps-0"
                    placeholder="you@think-gas.com"
                    value={form.email} onChange={handleChange} required autoComplete="email"
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold small">Password</label>
                <div className="input-group">
                  <span className="input-group-text bg-light border-end-0">
                    <i className="bi bi-lock text-muted"></i>
                  </span>
                  <input
                    type="password" name="password" className="form-control border-start-0 ps-0"
                    placeholder="••••••••"
                    value={form.password} onChange={handleChange} required autoComplete="current-password"
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn w-100 fw-bold py-2 mb-3 text-white"
                style={{ background: 'linear-gradient(90deg, #F2652C, #d4541e)', border: 'none', borderRadius: 10, fontSize: '0.95rem' }}
                disabled={loading}
              >
                {loading ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Signing in...</>
                ) : (
                  <><i className="bi bi-box-arrow-in-right me-2"></i>Sign In</>
                )}
              </button>
            </form>

            <>
              <div className="d-flex align-items-center gap-2 my-3">
                <hr className="flex-grow-1 m-0" />
                <span className="text-muted small px-1">or</span>
                <hr className="flex-grow-1 m-0" />
              </div>
              <button
                type="button"
                className="btn w-100 fw-semibold py-2 d-flex align-items-center justify-content-center gap-2"
                style={{ border: '1.5px solid #dadce0', borderRadius: 10, background: '#fff', color: '#3c4043', fontSize: '0.92rem' }}
                onClick={handleMsLogin}
                disabled={ssoLoading}
              >
                {ssoLoading ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1"  y="1"  width="9" height="9" fill="#f25022"/>
                    <rect x="11" y="1"  width="9" height="9" fill="#7fba00"/>
                    <rect x="1"  y="11" width="9" height="9" fill="#00a4ef"/>
                    <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                  </svg>
                )}
                Sign in with Microsoft
              </button>
            </>
          </div>

          <p className="text-center text-muted small mt-3">
            Authorized personnel only &nbsp;·&nbsp;
            <span style={{ color: '#F2652C', fontWeight: 600 }}>Think Gas</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
